import { Stack } from '@mui/material';
import styled from 'styled-components';

export const PopoverOptions = styled(Stack)`
  && {
    max-height: 500px;
    overflow: auto;
    gap: 2px;
  }
`;
